module.exports = __webpack_public_path__ + "img/brand-1.16e55f93.jpg";